import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  createBrowserRouter,
  RouterProvider,
  NavLink,
} from "react-router-dom";
import Hamburger from "hamburger-react";
import "./App(menu).css";
import { initTheme, switchTheme } from "../../js/theme";
import { captureInstall } from "../../js/sw-manager";
import MySchedule from "../pages/MySchedule";
import SwitchPage from "../pages/Switch";
import Home from "../pages/Home";
import SimilarSessions from "../pages/SimilarSessions";
import { checkDisclaimer } from "../../js/utils";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Drawer } from "@mui/material";

const queryClient = new QueryClient();

captureInstall();
initTheme();

const menuStyles = {
  bmItemList: {
    height: "auto",
  },
};
// .bm-item {
//     display: inline-block;
//     text-decoration: none;
//     color: var(--color3);
//     font-size: x-large;
//     padding: 15px 0px 15px 0px;
//     width: 100%;
//     text-align: center;
//     border-top: var(--color1) 2px solid;
// }
const sxStyle = {
  // .bm-item
  display: "inline-block",
  textDecoration: "none",
  color: "var(--color3)",
  fontSize: "x-large",
  padding: "15px 0px 15px 0px",
  width: "100%",
  textAlign: "center",
  borderTop: "var(--color1) 2px solid",
};

const Menu = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  return (
    <div>
      <Hamburger
        styles={menuStyles}
        toggled={isMenuOpen}
        toggle={() => setIsMenuOpen((v) => !v)}
        color="var(--color3)"
      />
      <Drawer
        anchor="left"
        open={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        PaperProps={{
          sx: {
            background: "var(--background)",
            color: "var(--text)",
            padding: "20px",
            // height: "auto" // autofill
            boxSizing: "border-box",
          },
        }}
        sx={{
          margin: "10px",
        }}
      >
        <NavLink
          style={{ ...sxStyle, borderTop: "none" }}
          exact={true}
          activeClassName="link-active"
          to="/"
        >
          <div className="menu-item" id="home-link">
            Home
          </div>
        </NavLink>
        <NavLink style={sxStyle} activeClassName="link-active" to="/switch">
          <div className="menu-item" id="switch-link">
            Schedule Switch
          </div>
        </NavLink>
        <NavLink
          style={sxStyle}
          activeClassName="link-active"
          to="/my_schedule"
        >
          <div className="menu-item" id="myScheudle-link">
            My Schedule
          </div>
        </NavLink>
        <div
          className="menu-item"
          id="changeTheme-button"
          onClick={switchTheme}
          style={{ ...sxStyle, border: "none" }}
        >
          Change Theme
        </div>
      </Drawer>
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/my_schedule",
    element: (
      <>
        <Menu />
        <MySchedule />
      </>
    ),
  },
  {
    path: "/switch",
    element: (
      <>
        <Menu />
        <SwitchPage />
      </>
    ),
  },
  {
    path: "/similar_sessions",
    element: (
      <>
        <Menu />
        <SimilarSessions />
      </>
    ),
  },
  {
    path: "/",
    element: (
      <>
        <Menu />
        <Home />
      </>
    ),
  },
]);

const App = () => {
  useEffect(() => {
    checkDisclaimer();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};

export default App;
